import Crypto from "crypto";
import {Normalizer} from "../types";
import {kanonikJson} from "../kanonik";
import {egmNormalizer} from "./egm";
import {takbisNormalizer} from "./takbis";
import {icradosyakaydiNormalizer} from "./icradosyakaydi";
import {bankahesapNormalizer} from "./bankahesap";
import {sgkhacizNormalizer} from "./sgkhaciz";
import {sgksskNormalizer} from "./sgkssk";
import {postacekiNormalizer} from "./postaceki";
import {mernisNormalizer} from "./mernis";

// Registry anahtarlari picker `name` degerleridir
// (src/components/pickers/TakipSorguAlanlariPicker.vue).
export const normalizerRegistry: Record<string, Normalizer> = {
    egm: egmNormalizer,
    takbis: takbisNormalizer,
    icradosyakaydi: icradosyakaydiNormalizer,
    bankahesap: bankahesapNormalizer,
    sgkhaciz: sgkhacizNormalizer,
    sgkssk: sgksskNormalizer,
    postaceki: postacekiNormalizer,
    mernis: mernisNormalizer,
};

// Registry'de normalizer'i olan alan icin normalizer'i dondurur, yoksa null.
export function normalizerBul(alan: string): Normalizer | null {
    return normalizerRegistry[alan] ?? null;
}

// Fallback hash icin: ham cevaptan volatil/gereksiz alanlari elip kalanin kanonik
// hash'ini uretir. `dosyaId` (dosyaOzetDVO icinde), `sorguTarihi`, `isMock`,
// `sorgulayanBilgileri` hash'e KATILMAZ — yoksa ayni sorgu her kosumda farkli
// hash uretir ve fark motoru surekli "degisti" der.
export function fallbackHash(cevap: any): string {
    let elenmis: any = cevap;
    if (cevap !== null && typeof cevap === "object" && !Array.isArray(cevap)) {
        elenmis = {...cevap};
        delete elenmis.dosyaOzetDVO;
        delete elenmis.sorguTarihi;
        delete elenmis.isMock;
        delete elenmis.sorgulayanBilgileri;
    }
    return Crypto.createHash("sha1")
        .update(kanonikJson(elenmis))
        .digest()
        .toString("hex");
}
